// @flow

import { parseQuery } from "../services/query/queries"

type ProjectName = "SmartFAQApp" | "ContactFormApp"

const getSmartFAQ = (
  projectName: ProjectName,
  version: ?string,
): Promise<?React.ComponentType<any> | { [string]: ?React.ComponentType<any> }> =>
  new Promise((resolve, reject) => {
    if (typeof window !== "object") {
      resolve(null)
      return
    }

    if (window[projectName]) {
      resolve(window[projectName])
      return
    }

    let url = ""

    const query = parseQuery(window.location.search)
    const branchParam = `${projectName}Branch`
    const branch = query[branchParam]
    const isProd = window.SP_GLOBALS.SKYPICKER_ENV === "production" && !window.SP_GLOBALS.IS_STAGING

    // Allow url overrides for MRs in frontend/smart-faq repo
    if (!isProd && branch && branch.match(/^branch-[a-zA-Z\-]+$/)) {
      url = `https://smartfaq.kiwi.com/scripts/smartFAQ/${branch}/${projectName}.js`
    } else if (version && version.match(/v\d+\.\d+\.\d+/)) {
      const path = version ? `/${version}` : ""
      url = `https://smartfaq.kiwi.com/scripts/smartFAQ${path}/${projectName}.js`
    } else {
      throw new Error(`Incorrect SmartFAQ version: ${String(version)}`)
    }

    const script = document.createElement("script")
    script.defer = true
    script.src = url
    script.onload = () => resolve(window[projectName])
    script.onerror = () => reject(new Error("Error while loading SmartFAQ"))

    if (!document.body) {
      reject(new Error("Unexpected: no DOM body object"))
      return
    }

    document.body.appendChild(script)
  })

export default getSmartFAQ
